import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import { muiBankTheme } from '../tools/theme';
const Media = Object.entries(muiBankTheme.mediaSizes).reduce((acc, [key, value]) => {
    return Object.assign(Object.assign({}, acc), { [key]: ({ children, }) => {
            const shouldRender = useMediaQuery(value);
            return shouldRender ? React.createElement(React.Fragment, null, children) : null;
        } });
}, {});
export { Media };
//# sourceMappingURL=Media.js.map